import axios from 'axios';

export interface MaintenanceStatus {
    enabled: boolean;
    test_account_session: boolean; // the maintenance test account is signed in: may use the system
    message_ja: string | null;
    message_en: string | null;
    start_at: string | null;
    end_at: string | null;
}

export const MAINTENANCE_PATH = '/maintenance';

/** No login needed. Returns null when the backend cannot be reached. */
export const getMaintenanceStatus = async (): Promise<MaintenanceStatus | null> => {
    try {
        const response = await axios.get('/api/maintenance/status');
        return (response?.data?.data as MaintenanceStatus) ?? null;
    } catch {
        return null;
    }
};
